import styled from "styled-components";

export const DeliveryComplementaryEmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #e0e2e6;
  background: #fff;

  .empty-state-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #3e434e;
    color: #fff;
    font-size: 1.75rem;
    margin-bottom: 1rem;
  }

  .empty-state-title {
    margin: 0 0 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
    color: #24272e;
  }

  .empty-state-description {
    margin: 0 0 1.25rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: #5d606f;
    max-width: 360px;
  }
`;
